module.exports = __webpack_public_path__ + "img/icon_kakai.567d8869.png";